import { Injectable } from '@angular/core';

import { WorkflowAction } from '@osos/shared/api';

import {
  LocalizedValueModel,
  WorkflowActionCommentValidationModeEnum,
  WorkflowActionDialogOptionsModel,
  WorkflowActionPresenterModel,
} from '@osos/shared/types';
import { ParserBase } from '../../bases/parser/parser-base';

@Injectable()
export class WorkflowActionParserService extends ParserBase<
  WorkflowAction,
  WorkflowActionPresenterModel
> {
  constructor() {
    super(WorkflowAction, WorkflowActionPresenterModel, 1);
  }
  getPresenterModel(model: WorkflowAction): WorkflowActionPresenterModel {
    const presenter = {} as WorkflowActionPresenterModel;

    presenter.id = model.id;
    presenter.name = model.name;
    presenter.description = model.description as LocalizedValueModel;
    presenter.isMainAction = !!model.isMainAction;
    presenter.dialogOptions = model.dialogOptions ?? {
      commentValidationMode: WorkflowActionCommentValidationModeEnum.Optional,
      showConfirmationDialog: true
    } as WorkflowActionDialogOptionsModel;


    presenter.targetStep = {
      isRelative: model.targetStep.isRelative,
      targetStep: model.targetStep.targetStep,
    };
    presenter.visible = model.visible;
    presenter.message = model.message;
    presenter.conditionalTargetSteps = model.conditionalTargetSteps;
    return presenter;
  }
  getDataModel(presenter: WorkflowActionPresenterModel): WorkflowAction {
    return {
      id: presenter.id,
      name: presenter.name,
      description: presenter.description,
      isMainAction: !!presenter.isMainAction,
      dialogOptions: presenter.dialogOptions ?? {
        commentValidationMode: WorkflowActionCommentValidationModeEnum.Optional,
        showConfirmationDialog: true
      } as WorkflowActionDialogOptionsModel,
      targetStep: presenter.targetStep,
      message: presenter.message,
      visible: presenter.visible,
      conditionalTargetSteps: presenter.conditionalTargetSteps,
    } as WorkflowAction;
  }
}
